/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseStatusEnum } from './UseCaseStatusEnum';
import {
  UseCaseStatusEnumFromJSON,
  UseCaseStatusEnumFromJSONTyped,
  UseCaseStatusEnumToJSON,
} from './UseCaseStatusEnum';
import type { EuAiActRiskClassEnum } from './EuAiActRiskClassEnum';
import {
  EuAiActRiskClassEnumFromJSON,
  EuAiActRiskClassEnumFromJSONTyped,
  EuAiActRiskClassEnumToJSON,
} from './EuAiActRiskClassEnum';
import type { Department } from './Department';
import { DepartmentFromJSON, DepartmentFromJSONTyped, DepartmentToJSON } from './Department';
import type { MaterialityEnum } from './MaterialityEnum';
import { MaterialityEnumFromJSON, MaterialityEnumFromJSONTyped, MaterialityEnumToJSON } from './MaterialityEnum';
import type { CustomFieldValueRead } from './CustomFieldValueRead';
import {
  CustomFieldValueReadFromJSON,
  CustomFieldValueReadFromJSONTyped,
  CustomFieldValueReadToJSON,
} from './CustomFieldValueRead';
import type { AiModels } from './AiModels';
import { AiModelsFromJSON, AiModelsFromJSONTyped, AiModelsToJSON } from './AiModels';

/**
 * Use case shape for the list endpoint: no per-model assessment data or
 * custom-questionnaire status, since the list view doesn't display either.
 * @export
 * @interface UseCaseList
 */
export interface UseCaseList {
  /**
   *
   * @type {number}
   * @memberof UseCaseList
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  businessOwner: string;
  /**
   *
   * @type {Array<Department>}
   * @memberof UseCaseList
   */
  readonly department: Array<Department>;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  purpose: string;
  /**
   *
   * @type {EuAiActRiskClassEnum}
   * @memberof UseCaseList
   */
  euAiActRiskClass: EuAiActRiskClassEnum;
  /**
   *
   * @type {UseCaseStatusEnum}
   * @memberof UseCaseList
   */
  status?: UseCaseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  updateUser?: string;
  /**
   *
   * @type {MaterialityEnum}
   * @memberof UseCaseList
   */
  materiality?: MaterialityEnum | null;
  /**
   *
   * @type {Date}
   * @memberof UseCaseList
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof UseCaseList
   */
  readonly readiness: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UseCaseList
   */
  questStatuses: { [key: string]: any };
  /**
   *
   * @type {Array<AiModels>}
   * @memberof UseCaseList
   */
  readonly aiModels: Array<AiModels>;
  /**
   *
   * @type {Array<CustomFieldValueRead>}
   * @memberof UseCaseList
   */
  readonly customFieldValues: Array<CustomFieldValueRead>;
}

/**
 * Check if a given object implements the UseCaseList interface.
 */
export function instanceOfUseCaseList(value: object): value is UseCaseList {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('businessOwner' in value) || value['businessOwner'] === undefined) return false;
  if (!('department' in value) || value['department'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('purpose' in value) || value['purpose'] === undefined) return false;
  if (!('euAiActRiskClass' in value) || value['euAiActRiskClass'] === undefined) return false;
  if (!('readiness' in value) || value['readiness'] === undefined) return false;
  if (!('questStatuses' in value) || value['questStatuses'] === undefined) return false;
  if (!('aiModels' in value) || value['aiModels'] === undefined) return false;
  if (!('customFieldValues' in value) || value['customFieldValues'] === undefined) return false;
  return true;
}

export function UseCaseListFromJSON(json: any): UseCaseList {
  return UseCaseListFromJSONTyped(json, false);
}

export function UseCaseListFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseList {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    businessOwner: json['business_owner'],
    department: (json['department'] as Array<any>).map(DepartmentFromJSON),
    description: json['description'],
    purpose: json['purpose'],
    euAiActRiskClass: EuAiActRiskClassEnumFromJSON(json['eu_ai_act_risk_class']),
    status: json['status'] == null ? undefined : UseCaseStatusEnumFromJSON(json['status']),
    updateUser: json['update_user'] == null ? undefined : json['update_user'],
    materiality: json['materiality'] == null ? undefined : MaterialityEnumFromJSON(json['materiality']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    readiness: json['readiness'],
    questStatuses: json['quest_statuses'],
    aiModels: (json['ai_models'] as Array<any>).map(AiModelsFromJSON),
    customFieldValues: (json['custom_field_values'] as Array<any>).map(CustomFieldValueReadFromJSON),
  };
}

export function UseCaseListToJSON(
  value?: Omit<UseCaseList, 'id' | 'department' | 'readiness' | 'aiModels' | 'customFieldValues'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    business_owner: value['businessOwner'],
    description: value['description'],
    purpose: value['purpose'],
    eu_ai_act_risk_class: EuAiActRiskClassEnumToJSON(value['euAiActRiskClass']),
    status: UseCaseStatusEnumToJSON(value['status']),
    update_user: value['updateUser'],
    materiality: MaterialityEnumToJSON(value['materiality']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    quest_statuses: value['questStatuses'],
  };
}
